import { GTagEventNameType, GTagEventParamsType } from './types';

export const ObjectIsNotEmpty = (obj: any) => {
  return obj && Object.keys(obj).length > 0 && obj.constructor === Object;
};

export const trackEvent = (
  eventName: GTagEventNameType,
  eventParams: GTagEventParamsType
) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

const mimeTypes = [
  'audio/webm', //android
  'audio/wav',
  'audio/ogg',
  'audio/mpeg',
  'audio/mp4', //ios
  'audio/aac',
  'audio/flac',
  'audio/m4a',
  'audio/x-matroska',
  'audio/x-wav',
  'audio/x-aac',
  'audio/x-caf',
  'audio/x-flac',
];

export const getMimeType = () => {
  for (let i = 0; i < mimeTypes.length; i++) {
    if (MediaRecorder.isTypeSupported(mimeTypes[i])) {
      return mimeTypes[i];
    }
  }
  return '';
};
